import React from 'react';
import './FormElements.css';

// ---------------------------------------------------------------------------
// Label
// ---------------------------------------------------------------------------

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
    required?: boolean;
}

export const Label: React.FC<LabelProps> = ({ children, required, className = '', ...rest }) => (
    <label className={`cu-label ${className}`.trim()} {...rest}>
        {children}
        {required && <span className="cu-label-required" aria-hidden>*</span>}
    </label>
);

// ---------------------------------------------------------------------------
// Input
// ---------------------------------------------------------------------------

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    className?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className = '', ...rest }, ref) => (
        <input ref={ref} className={`cu-input ${className}`.trim()} {...rest} />
    )
);
Input.displayName = 'Input';

// ---------------------------------------------------------------------------
// Textarea
// ---------------------------------------------------------------------------

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    className?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className = '', ...rest }, ref) => (
        <textarea ref={ref} className={`cu-input cu-textarea ${className}`.trim()} {...rest} />
    )
);
Textarea.displayName = 'Textarea';

// ---------------------------------------------------------------------------
// Select
// ---------------------------------------------------------------------------

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
    className?: string;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
    ({ className = '', children, ...rest }, ref) => (
        <select ref={ref} className={`cu-select ${className}`.trim()} {...rest}>
            {children}
        </select>
    )
);
Select.displayName = 'Select';
